import React, { ReactElement, ReactNode } from 'react';
import { useTracking } from '.';

export interface PageRouteProps {
  id: string;
  children: ReactNode;
}

const trackedPages: Record<string, boolean> = {};

export function PageScope({ children, id }: PageRouteProps): ReactElement {
  const trackingService = useTracking();

  React.useEffect(() => {
    if (!trackedPages[id]) {
      const stepPages = new Set([
        "vehicle-details-page",
        "service-request-page",
        "customer-contact-page",
        "select-dealer-page",
        "select-service-date-page"
      ]);

      const excludedFromPageLoad = new Set([
        "verify-booking-details-page",
        "send-confirmation-message-page"
      ]);

      if (stepPages.has(id)) {
        trackingService.trackStepPageLoad({ contentId: id });
      } else if (!excludedFromPageLoad.has(id)) {
        trackingService.trackPageLoad({ contentId: id });
      }

      trackedPages[id] = true;
    }

    return () => {
      setTimeout(() => {
        if (trackedPages[id]) {
          trackedPages[id] = false;
        }
      }, 0);
    };
  }, [id, trackingService]);

  return <>{children}</>;
}

